import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchCasesBasic } from '@/services/site';

/**
 * 获取投诉下拉框数据
 * - retails 零售经理
 * - dispose_type 赔偿内容
 * - source 投诉来源
 * - cases_status 处理状态
 * - category 投诉分类
 */
const useCasesBasic = () => {
  const { casesBasic, setCasesBasic } = useReadyInfo();

  const { run: getCasesBasic, data, loading } = useRequest(fetchCasesBasic, { manual: true });

  useEffect(() => {
    if (
      !casesBasic ||
      !casesBasic?.retails ||
      !casesBasic?.dispose_type ||
      !casesBasic?.source ||
      !casesBasic?.cases_status ||
      !casesBasic?.category
    ) {
      getCasesBasic().then((res) =>
        setCasesBasic({
          retails:
            res?.retails?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          dispose_type:
            res?.dispose_type?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          source:
            res?.source?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          cases_status:
            res?.cases_status?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          category:
            res?.category?.map((v) => {
              return { label: v.name, value: v.id, role: v.role };
            }) ?? [],
        })
      );
    }
  }, [casesBasic]);

  return {
    data: casesBasic || {
      retails:
        data?.retails?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      dispose_type:
        data?.dispose_type?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      source:
        data?.source?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      cases_status:
        data?.cases_status?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      category:
        data?.category?.map((v) => {
          return { label: v.name, value: v.id, role: v.role };
        }) ?? [],
    },
    loading,
  };
};

export default useCasesBasic;
